/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportScheduleParameter {
    getFixupPrototypeFunction() { return ReportScheduleParameter.fixupPrototype; }

    static newInstance(model: Partial<ReportScheduleParameter>): ReportScheduleParameter {
        let obj = Object.assign(new ReportScheduleParameter(), model);
        ReportScheduleParameter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportScheduleParameter>): ReportScheduleParameter {
        if (!model) return null;
        return ReportScheduleParameter.newInstance(<ReportScheduleParameter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportScheduleParameter) {
        if (!obj) return;

        models.ReportScheduleParameter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportScheduleParameter): boolean {
        Object.setPrototypeOf(obj, ReportScheduleParameter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * SSRS report parameter name
     */
    name: string;

    /**
     * Value selected for the parameter
     */
    value: string;

    /**
     * Display label of the parameter, e.g. Tenant
     */
    label: string;

    /**
     * Display text of the selected value
     */
    value_label: string;

}
